/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Create_Event_Group_Start_TimeInputs */

const en_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Time`)
};

const fr_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de debut`)
};

const de_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startzeit`)
};

const it_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora di inizio`)
};

const ru_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время начала`)
};

const es_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de inicio`)
};

const zh_cn2_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时间`)
};

const ja_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間`)
};

const hi_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय शुरू`)
};

const pt_pt2_markers_create_event_group_start_time = /** @type {(inputs: Markers_Create_Event_Group_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de início`)
};

/**
* | output |
* | --- |
* | "Start Time" |
*
* @param {Markers_Create_Event_Group_Start_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_create_event_group_start_time = /** @type {((inputs?: Markers_Create_Event_Group_Start_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Create_Event_Group_Start_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_create_event_group_start_time(inputs)
	if (locale === "de") return de_markers_create_event_group_start_time(inputs)
	if (locale === "it") return it_markers_create_event_group_start_time(inputs)
	if (locale === "ru") return ru_markers_create_event_group_start_time(inputs)
	if (locale === "es") return es_markers_create_event_group_start_time(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_create_event_group_start_time(inputs)
	if (locale === "ja") return ja_markers_create_event_group_start_time(inputs)
	if (locale === "hi") return hi_markers_create_event_group_start_time(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_create_event_group_start_time(inputs)
	return en_markers_create_event_group_start_time(inputs)
});